module.exports = __webpack_public_path__ + "img/2-Densidad de poblacion.06f1dffd.jpg";